'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const ControllerDefaults={
selectedDate:null,
numDaysAvailable:null,
timeOfDay:null,
isMinimized:!1};


const _numDayOptions=[1,2,3,4,5];
const _timeOfDayOptionsInHoursSinceMidnight=['03:00','07:00','12:00'];let

DateTimeSelectorController=function(){
function DateTimeSelectorController($scope,$timeout,timeZoneService){_classCallCheck(this,DateTimeSelectorController);
this._$scope=$scope;
this._$timeout=$timeout;
this._timeZoneService=timeZoneService;

_.defaults(this,ControllerDefaults);

this.availableOptions=_.clone({
numDaysAvailable:_numDayOptions,
timeOfDay:_timeOfDayOptionsInHoursSinceMidnight});

}_createClass(DateTimeSelectorController,[{key:'localTimeZone',get:function()

{
return this._timeZoneService.localTimeZone;
}}]);return DateTimeSelectorController}();let


DateTimeSelectorDirective=function(_BaseControllerBacked){_inherits(DateTimeSelectorDirective,_BaseControllerBacked);function DateTimeSelectorDirective(){_classCallCheck(this,DateTimeSelectorDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DateTimeSelectorDirective,[{key:'templateUrl',get:function()
{return'/templates/features/emirates/emiratesDashboard/components/dateTimeSelectorDirective/dateTimeSelectorTemplate'}},{key:'objectBindings',get:function()

{return _.keys(ControllerDefaults)}},{key:'$inject',get:function()

{return['$scope','$timeout','timeZoneService']}},{key:'controller',get:function()

{return DateTimeSelectorController}}]);return DateTimeSelectorDirective}(BaseControllerBackedDirective);


module.exports=DateTimeSelectorDirective;
//# sourceMappingURL=dateTimeSelectorDirective.js.map
